import styled from 'styled-components';
import dt from '../../../shared/theme';

const Container = styled.div`
  width: 100%;

  .bookmark {
    margin-left: auto;
    margin-top: -12px;

    ${props => dt(props).theme.isMobileOrTablet && `
      min-width: unset;
      height: unset;
      margin-top: -6px;
      padding: 0;
      border-color: transparent;
    `}
  }
`;

const Secondary = styled.span`
  &&, & > a {
    color: ${props => dt(props).theme.secondaryColor};
  }
`;

const Separator = styled(Secondary)`
  margin: 0 5px;
`;

const TopLine = styled.div`
  margin-bottom: 5px;
  font-size: 14px;

  span {
    margin-right: 12px;
  }
`;

const BottomLine = styled.div`
  display: flex
`;

export {
  Container,
  Secondary,
  Separator,
  TopLine,
  BottomLine,
};
